import { Col, Container, Navbar, Row } from 'react-bootstrap';
import { useTheme } from 'styled-components';

import Copyright from './Copyright';

const Footer = () => {
  const theme = useTheme();

  return (
    <Row>
      <Col className="p-0">
        <Navbar variant="dark" className="pr-0 mt-0 background-color-footer">
          <Container fluid="xl" className="flex-column pt-1">
            <Copyright
              className="py-4 text-center"
              color={theme.colors.footerText}
              lineHeight={theme.base.typography.body.lineHeight}
              fontWeight={theme.fonts.fontWeights.demi}
            >
              <p>
                &copy; {new Date().getFullYear()} {theme.language.appName}. All Rights Reserved.
                <br />
                <a href={theme.links.termsAndConditions.link} target="_blank">
                  Terms of Service
                </a>
                {' | '}
                <a href={theme.links.privacyPolicy.link} target="_blank">
                  Privacy Policy
                </a>
              </p>
            </Copyright>
          </Container>
        </Navbar>
      </Col>
    </Row>
  );
};

export default Footer;
